import React from "react";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Head from "next/head";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import styles from "./index.module.scss";
import Layout from "@/components/layout";
import Faqs from "@/components/faqs";
import buriedSdk from "@/utils/zz-buried/index";
import { fakeDatas } from "@/utils/fakeData";
import { getToken } from "@/utils/auth";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";

import AboutBanner from "@images/affiliate/bg.png";
import p1 from "@images/affiliate/p1.png";
import p2 from "@images/affiliate/p2.png";
import p3 from "@images/affiliate/p3.png";
import p4 from "@images/affiliate/p4.png";
import bg2 from "@images/affiliate/bg2.png";
import p5 from "@images/affiliate/p5.png";
import p6 from "@images/affiliate/p6.png";
import p7 from "@images/affiliate/p7.png";
import p8 from "@images/affiliate/p8.png";
import p9 from "@images/affiliate/p9.png";
import p10 from "@images/affiliate/p10.png";
import p11 from "@images/affiliate/p11.png";
import world from "@images/affiliate/world.png";

import ca from "@images/country/ca.png";
import de from "@images/country/de.png";
import en from "@images/country/en.png";
import fr from "@images/country/fr.png";
import gb from "@images/country/gb.png";
import id from "@images/country/id.png";
import vi from "@images/country/vi.png";

interface contentsType {
  Nation: string;
  Account: string;
  withdrawal: string;
  id: number;
}

const Affiliate: NextPage<{
  context: any;
  isLogin: Boolean
}> = (props) => {
  const [data, setData] = useState<contentsType[]>([]);
  const { t } = useTranslation(["affiliate"]);
  const { locale } = useRouter();

  const list = [
    {
      question: t("Q1"),
      id: 1,
      answer: t("A1"),
      isShow: true,
    },
    {
      question: t("Q2"),
      id: 2,
      answer: t("A2"),
      isShow: false,
    },
    {
      question: t("Q3"),
      id: 3,
      answer: t("A3"),
      isShow: false,
    },
    {
      question: t("Q4"),
      id: 4,
      answer: t("A4"),
      isShow: false,
    },
  ];
  const moreList = [
    {
      question: t("Q5"),
      id: 5,
      answer: t("A5"),
      isShow: false,
    },
    {
      question: t("Q6"),
      id: 6,
      answer: t("A6"),
      isShow: false,
    },
    {
      question: t("Q7"),
      id: 7,
      answer: t("A7"),
      slotNode: (
        <div>
          {t("A7")
            .split("\n")
            .map((i, idx) => (
              <p key={idx} style={{ margin: 0 }}>
                {i}
              </p>
            ))}
        </div>
      ),
      isShow: false,
    },
    {
      question: t("Q8"),
      id: 8,
      answer: t("A8"),
      isShow: false,
    },
    {
      question: t("Q9"),
      id: 9,
      answer: t("A9"),
      isShow: false,
    },
    {
      question: t("Q10"),
      id: 10,
      answer: t("A10"),
      slotNode: (
        <div>
          {t("A10-1")}
          <a href={`mailto:${t("A10-2")}`}>{t("A10-2")}</a>
          {t("A10-3")}
        </div>
      ),
      isShow: false,
    },
  ];

  const newData = fakeDatas.map((item, index) => ({ ...item, id: index }));

  const getImg = (code: String) => {
    switch (code) {
      case "US":
        return en;
      case "CA":
        return ca;
      case "GB":
        return gb;
      case "DE":
        return de;
      case "FR":
        return fr;
      case "ID":
        return id;
      case "VN":
        return vi;
      default:
        return "";
    }
  };

  const burid = (scene) => {
    buriedSdk.buried({
      event: `按钮点击`,
      scene: scene,
      URL: process.env.publicApiDomain,
    });
  };

  const toQuestionnaire = () => {
    let url = "";
    switch (locale) {
      case "vi":
        url =
          "https://qfreeaccountssjc1.az1.qualtrics.com/jfe/form/SV_1G2WwheA92cFK0m";
        break;
      case "id":
        url =
          "https://qfreeaccountssjc1.az1.qualtrics.com/jfe/form/SV_0BVfHK7Coiq2Dyu";
        break;
      default:
        url =
          "https://qfreeaccountssjc1.az1.qualtrics.com/jfe/form/SV_8BTwim9zmc7zr3U";
        break;
    }
    window.open(url);
    burid("点击落地页按钮跳转至问卷调查");
  };

  return (
    <div className="bg-[#fff]">
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("seo title")}</title>
          <meta name="keywords" content={t("seo keywords")} />
          <meta name="description" content={t("seo description")} />
        </Head>
        <div className={styles.affiliate}>
          <div className={styles.banner}>
            <div className={`defeaultContainer ${styles.top}`}>
              <div
                className={`flex  justify-between  animate-box ${styles.topwrap}`}
              >
                <div className={styles.left + "  ant"}>
                  <h1
                    className={
                      styles.Regular +
                      " text-[24px] text-[#191919] font-normal leading-[48px] m-0"
                    }
                  >
                    {t("title1")}
                  </h1>
                  <h2 className="text-[52px] text-[#191919] font-bold leading-[64px] !mb-[16px]">
                    {t("title2")}
                  </h2>
                  <p
                    className={
                      styles.Regular +
                      " text-[18px] text-[#191919] font-[400] leading-[24px] m-0"
                    }
                  >
                    {t("tips")}
                  </p>
                  <a className={styles.countMe} onClick={toQuestionnaire}>
                    {t("Count Me In")}
                  </a>
                  <p
                    className={
                      styles.Regular +
                      " text-[16px] text-[#191919] font-normal leading-[24px]"
                    }
                  >
                    {t("Already a Partner")}
                    <a
                      key="View More"
                      className="ml-[8px] !text-[#ff3e5f]"
                      href={props.isLogin ? '/user?name=affiliate' : '/login?fromPath=%2Fuser%3Fname%3Daffiliate'}
                      onClick={() => burid(`落地页首张banner图-${props.isLogin ? 'View more' : 'Login'}`)}
                    >
                      {props.isLogin ? t("View More") : t("Login")}
                    </a>
                  </p>
                </div>
                <div className={`${styles.right}`}>
                  <div className={styles.pic}>
                    <Image className="ant" alt="" src={AboutBanner}></Image>
                    <div className="ant absolute w-[90px] h-[90px] left-[13px] top-[64px]">
                      <Image alt="" src={p1}></Image>
                    </div>
                    <div className="ant absolute w-[240px] h-[95px] right-[-41px] top-[135px]">
                      <div className={styles["img-wrap"]}></div>
                      <Image alt="" src={p2}></Image>
                    </div>
                    <div className="ant absolute w-[237px] h-[80px] left-[-36px] bottom-[147px]">
                      <div className={styles["img-wrap"]}></div>
                      <Image alt="" src={p3}></Image>
                    </div>
                    <div className="ant absolute w-[241px] h-[144px] right-[-41px] bottom-[69px]">
                      <div className={styles["img-wrap"]}></div>
                      <Image alt="" src={p4}></Image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="defeaultContainer pt-[101px] pb-[85px] animate-box">
            <h2 className={styles.secTitle + " w-[1016px] ant"}>
              {t("sectitle")}
            </h2>
            <div className={styles.withdrawal + "  ant"}>
              <Image alt="" src={bg2}></Image>
              <div className={styles.list}>
                <div className="text-[24px] leading-[30px] font-[600] text-[#191919] mb-[6px]">
                  {t("Withdrawal list")}
                </div>
                <div className="w-full bg-[#F4E9DA] rounded-[8px] px-[11px] py-[6px] flex">
                  <div className="w-[30%] text-[14px] leading-[20px] font-[500] text-[#191919]">
                    {t("Nation")}
                  </div>
                  <div className="w-[40%] text-[14px] leading-[20px] font-[500] text-[#191919]">
                    {t("Account")}
                  </div>
                  <div className="w-[30%] text-[14px] leading-[20px] font-[500] text-[#191919]">
                    {t("Cash withdrawal")}
                  </div>
                </div>
                <div className="">
                  <Swiper
                    className="linear-animation h-[230px]"
                    modules={[Autoplay]}
                    direction="vertical"
                    spaceBetween={0}
                    loop={true}
                    speed={3000}
                    observer={true}
                    observeParents={true}
                    autoplay={{ delay: 0, disableOnInteraction: false }}
                    slidesPerView={5}
                  >
                    {newData.map((item, index) => (
                      <SwiperSlide key={item.id}>
                        <div
                          className={
                            styles["list-item"] +
                            " w-full px-[11px] py-[12px] flex"
                          }
                          key={item.id}
                        >
                          <div className="flex w-[30%]">
                            <div className="w-[21px] h-[21px] rounded-[100%] mr-[8px]">
                              <Image alt="" src={getImg(item.Nation)}></Image>
                            </div>
                            <span className="text-[14px] leading-[20px] font-[400] text-[#191919]">
                              {item.Nation}
                            </span>
                          </div>
                          <div className="w-[40%] text-[14px] leading-[20px] font-[400] text-[#191919]">
                            {item.Account}
                          </div>
                          <div className="w-[30%] text-[14px] leading-[20px] font-[400] text-[#191919]">
                            {item.withdrawal}
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.secContent2}>
            <div className="defeaultContainer animate-box">
              <h2 className={styles.secTitle + " ant"}>{t("sectitle2")}</h2>
              <p className={styles.secTips + " ant"}>{t("sectips2")}</p>
              <div className={styles.deserve}>
                <div className={styles.deserve_item + " ant"}>
                  <div className="w-[96px] h-[96px] mb-[36px]">
                    <Image alt="" src={p5}></Image>
                  </div>
                  <h3 className={styles.title}>{t("sec2 Item title1")}</h3>
                  <p className={styles.desc}>{t("sec2 Item tips1")}</p>
                </div>
                <div className={styles.deserve_item + " ant"}>
                  <div className="w-[96px] h-[96px] mb-[36px]">
                    <Image alt="" src={p6}></Image>
                  </div>
                  <h3 className={styles.title}>{t("sec2 Item title2")}</h3>
                  <p className={styles.desc}>{t("sec2 Item tips2")}</p>
                </div>
                <div className={styles.deserve_item + " ant"}>
                  <div className="w-[96px] h-[96px] mb-[36px]">
                    <Image alt="" src={p7}></Image>
                  </div>
                  <h3 className={styles.title}>{t("sec2 Item title3")}</h3>
                  <p className={styles.desc}>{t("sec2 Item tips3")}</p>
                </div>
                <div className={styles.deserve_item + " ant"}>
                  <div className="w-[96px] h-[96px] mb-[36px]">
                    <Image alt="" src={p8}></Image>
                  </div>
                  <h3 className={styles.title}>{t("sec2 Item title4")}</h3>
                  <p className={styles.desc}>{t("sec2 Item tips4")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="defeaultContainer pt-[100px] pb-[132px] animate-box">
            <h2 className={styles.secTitle + " ant"}>{t("sectitle3")}</h2>
            <div className={styles.works}>
              <div className={styles["work-item"] + " ant"}>
                <div className="w-[120px] h-[120px] mb-[56px] mt-[-41px]">
                  <Image alt="" src={p9}></Image>
                </div>
                <h3 className={styles.title}>{t("sec3 Item title1")}</h3>
                <p className={styles.desc}>
                  {t("Simply")}
                  <a onClick={toQuestionnaire}>{t("click here")}</a>
                  {t("sec3 Item tips1")}
                </p>
              </div>
              <div className={styles["work-item"] + " ant"}>
                <div className="w-[120px] h-[120px] mb-[56px] mt-[-41px]">
                  <Image alt="" src={p10}></Image>
                </div>
                <h3 className={styles.title}>{t("sec3 Item title2")}</h3>
                <p className={styles.desc}>{t("sec3 Item tips2")}</p>
              </div>
              <div className={styles["work-item"] + " ant"}>
                <div className="w-[120px] h-[120px] mb-[56px] mt-[-41px]">
                  <Image alt="" src={p11}></Image>
                </div>
                <h3 className={styles.title}>{t("sec3 Item title3")}</h3>
                <p className={styles.desc}>{t("sec3 Item tips3")}</p>
              </div>
            </div>
          </div>

          <div className={styles.secContent4}>
            <div className="defeaultContainer animate-box">
              <h2 className={styles.secTitle + " ant"}>{t("sectitle4")}</h2>
              <p className={styles.secTips + " w-[980px] !mx-[auto] ant"}>
                {t("sectips4")}
              </p>
              <div className="text-center ant">
                <a className={styles.started} onClick={toQuestionnaire}>
                  {t("Get started")}
                </a>
              </div>
              <div className="w-[1200px] h-[467px] mx-[auto] ant">
                <Image alt="" src={world}></Image>
              </div>
            </div>
          </div>

          <div>
            <Faqs list={list} moreList={moreList}></Faqs>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
        "affiliate",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
      isLogin: !!context.req.cookies['authorized-token'],
    },
  };
};
export default Affiliate;
